export default {
  settings: {
    // TODO: Translate (PWA)
    changeSettingsPasscode: 'Cambia le impostazioni del passacodice',
    chooseDefaultSurvey: 'Scegli sondaggio predefinito',
    congratulations: 'Congratulazioni!',
    downloadSurveys: 'Scarica le ultime impostazioni del sondaggio',
    heading: 'Impostazioni',
    lastSynchronised: 'Ultima sincronizzazione del dispositivo: {n}',
    lastUploaded: 'Ultimi sondaggi caricati sul dispositivo: {n}',
    manageTeam: 'Gestisci squadra',
    never: 'Mai',
    resetConfirmation: 'Sei sicuro di voler ripristinare questo dispositivo?',
    resetDevice: 'Ripristina dispositivo',
    resetError: 'Non è stato possibile annullare la registrazione del tuo dispositivo. Questo dovrà essere fatto manualmente tramite il back office.',
    resetSuccess: 'Abbiamo ripristinato con successo il tuo dispositivo.',
    resetWait: 'Attendere mentre stiamo ripristinando il tuo dispositivo',
    surveysDownloaded: 'Le ultime impostazioni del sondaggio sono state scaricate con successo.',
    surveysDownloadError: 'Impossibile scaricare le impostazioni del sondaggio.',
    surveysDownloading: 'Attendere mentre scarichiamo le ultime impostazioni del sondaggio',
    surveysUploaded: 'Not Implemented.',
    surveysUploadError: 'Not Implemented.',
    surveysUploadErrorTitle: 'Not Implemented.',
    surveysUploading: 'Attendere mentre carichiamo i sondaggi completati',
    surveyUploadedCount: 'Not Implemented.',
    uploadSurveys: 'Not Implemented.',
    updateApp: 'Not Implemented.',
    appUpdating: 'Not Implemented.',
    appUpdated: 'Not Implemented.',
    updateAvailable: 'Not Implemented.',
    menuInsights: {
      download: 'Scarica i prodotti',
      downloading: 'Attendere mentre scarichiamo i tuoi prodotti',
      complete: 'Congratulazioni! Gli ultimi prodotti sono stati scaricati con successo',
      error: 'Non siamo riusciti a scaricare gli ultimi prodotti'
    },
    isStandAlone: 'È Stand-alone: ',
    isAPK: 'È APK: ',
    pwaStatuses: 'PWA Stati',
    pwaMode: 'È in funzione come: ',
    pwaModes: {
      apk: 'Installato APK',
      pwa: 'Installato PWA',
      web: 'Browser'
    },
    yes: 'Sì',
    no: 'No'
  }
};